export default __webpack_public_path__ + "static/media/13.28ec55b0.JPG";